angular.module('livecam', ['pascalprecht.translate', 'core', 'amateurPool', 'userPool'])
  .directive('onsdLivecams', ['PimpMyRide', 'Livecam', (PimpMyRide, Livecam) => PimpMyRide('Livecams', false, Livecam.list)])
  .directive('onsdLivecamsLoading', ['PimpMyRide', 'Livecam', (PimpMyRide, Livecam) => PimpMyRide('LivecamsLoading', false, Livecam.getLoadingList)]);
